var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-cy":"company-button-add"}},[_c('b-avatar',{staticClass:"cy-add-customer-fab floating-action-btn btn-danger mb-5 position-fixed cursor-pointer",attrs:{"button":"","size":"4.8rem"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":require("@/assets/icons/floating_plus.svg"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }